/**
 * @jest-environment node
 */
import React from 'react'
import * as S from './Home.styled'
import UpperBlocks from './UpperBlocks/UpperBlocks'
import BannersCarousel from './BannersCarusel/BannersCarousel'
import { SearchGoodsInput } from 'src/features/search-goods/ui'
import { useStore } from 'effector-react'
import { $isOpenedSearchSection } from 'src/features/search-goods/model' /*<MobileHeader
  blockRef={blockHeaderRef}
  searchInput={{
    isShowed: true
  }}>
  {group?.title || 'Каталог'}
</MobileHeader>*/

/*<MobileHeader
  blockRef={blockHeaderRef}
  searchInput={{
    isShowed: true
  }}>
  {group?.title || 'Каталог'}
</MobileHeader>*/
const Home = () => {
    const isVisibleSuggestions = useStore($isOpenedSearchSection)

    return (
        <S.Container>
            <S.Header>
                {isVisibleSuggestions ? (
                    <React.Fragment />
                ) : (
                    <S.HeaderBody>
                        <S.LogoContainer>
                            <S.GeneralLogo />
                        </S.LogoContainer>
                    </S.HeaderBody>
                )}
                <SearchGoodsInput />
            </S.Header>
            <S.Body>
                <UpperBlocks />
                <BannersCarousel />
            </S.Body>
        </S.Container>
    )
}

Home.propTypes = {}

export default Home
